import { IconButton } from "@mui/material";
import { VolumeUp as VolumeUpIcon } from "@mui/icons-material";
import { useSpeech } from "react-text-to-speech";

/**
 * TextToSpeechButton - A reusable button component for text-to-speech functionality
 *
 * @param {Object} props
 * @param {string} props.text - The text to be spoken (required)
 * @param {number} props.rate - Speech rate (default: 0.9)
 * @param {number} props.pitch - Speech pitch (default: 1)
 * @param {number} props.volume - Speech volume (default: 1)
 * @param {string} props.size - IconButton size (default: "small")
 * @param {string} props.color - IconButton color (default: "primary")
 * @param {Object} props.sx - Additional Material-UI sx styles
 */
const TextToSpeechButton = ({
  text,
  rate = 0.9,
  pitch = 1,
  volume = 1,
  size = "small",
  color = "primary",
  sx = {},
  ...otherProps
}) => {
  const { speechStatus, start, stop } = useSpeech({
    text,
    rate,
    pitch,
    volume,
    lang: "en-US",
  });

  const handleClick = () => {
    if (speechStatus === "started") {
      stop();
    } else {
      start();
    }
  };

  return (
    <IconButton
      color={speechStatus === "started" ? "inherit" : color}
      onClick={handleClick}
      size={size}
      sx={{
        bgcolor: speechStatus === "started" ? "primary.light" : "transparent",
        "&:hover": {
          bgcolor: speechStatus === "started" ? "primary.main" : "action.hover",
        },
        ...sx,
      }}
      {...otherProps}
    >
      <VolumeUpIcon />
    </IconButton>
  );
};

export default TextToSpeechButton;
